












import { Vue, Component } from 'vue-property-decorator';
import Summary from './summary.vue';
import Chat from './chat.vue';

@Component({
    components: {
        Summary,
        Chat
    }
})
export default class extends Vue {
    private activeTab = 'chat'; // 默认显示 chat
}
